<template>
	<div class="row my-4">
		<div class="col-sm-12 position-relative border border-warning">
			<div class="row mb-2">
				<h5 class="bg-info p-2">Other</h5>
			</div>
			<div class="row">
				<div class="form-group col-sm-6">
					<BaseMultiSelect
						@update:value="setCountry"
						:options="multiSelectState.countriesSelect"
						rules="required"
						name="Country"
						mode="single"
						:required="true"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div v-if="data.country.name" class="form-group col-sm-6 mb-6">
					<BaseMultiSelect
						@update:value="setState"
						:options="multiSelectState.statesSelect"
						rules="required"
						name="State"
						:required="true"
						mode="tags"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-4">
					<BaseInput
						name="Travel Date"
						label="Travel Date"
						type="date"
						:min="`${new Date().getFullYear()}-${
							new Date().getMonth() + 1 < 10
								? '0' + (new Date().getMonth() + 1)
								: new Date().getMonth() + 1
						}-${new Date().getDate() + 1}`"
						v-model="data.travelDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>

				<div class="form-group col-sm-4">
					<BaseInput
						name="No. of Days"
						label="No. of Days"
						type="number"
						:min="1"
						:required="true"
						v-model="data.numberOfDays"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
				<div class="form-group col-sm-4">
					<BaseInput
						name="Sub Category"
						label="Sub Category"
						type="text"
						:required="true"
						v-model="data.subCategory"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="inputError"
						@valSuccess="inputSuccess"
					/>
				</div>
			</div>
			<div class="form-group col-sm-12 my-4">
				<BaseEditor
					@updateData="setEditorData"
					name="Description"
					:required="true"
				/>
			</div>
		</div>
	</div>
</template>
<script>
	import { reactive, watch, inject } from "vue";
	import Helper from "@/helpers/dataHelper";

	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseEditor from "./BaseEditor.vue";

	export default {
		name: "LeadOther",
		components: {
			BaseInput,
			BaseMultiSelect,
			BaseEditor,
		},
		props: {
			count: { type: Number, default: 0 },
		},
		emits: ["updateData"],
		setup: (props) => {
			const leadState = inject("leadState");

			const data = reactive({
				status: true,
				country: {
					id: 0,
					name: null,
				},
				states: [],
				travelDate: null,
				numberOfDays: 0,
				subCategory: null,
				description: "",
			});

			watch(
				() => data,
				(preValue, newValue) => {
					if (
						data.country.name &&
						data.travelDate &&
						data.states.length &&
						data.description
					) {
						leadState.state.data.other = { ...data };
					}
				},
				{ deep: true },
			);

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],
				cities: [],
				citiesSelect: [],
				states: [],
				statesSelect: [],
			});

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};
			getCountries();

			const setCountry = (dataObj) => {
				if (!dataObj) {
					data.country.id = 0;
					data.country.name = null;
					return;
				}
				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				data.country.id = country[0].id;
				data.country.name = country[0].name;
				getStates();
			};

			const getStates = async (stateObj = false) => {
				let stateData = {};

				if (stateObj?.name && stateObj.name.length < 3) return;
				else if (stateObj?.name && stateObj.name.length > 3)
					stateData.name = stateObj.name;

				if (data.country.name) {
					stateData.countryName = data.country.name;
				} else if (!stateObj && !data.country.name) return;
				try {
					const response = await Helper.getStates(stateData);
					let states = response.data;

					multiSelectState.states = [...states];

					const changeFormat = states.map((state) => {
						return { label: state.name, value: state.id };
					});

					multiSelectState.statesSelect = [...changeFormat];
				} catch (error) {
					console.log("error fetching states: :(");
				}
			};

			const setState = (dataObj) => {
				if (!dataObj.length) {
					data.states = [];
					return;
				}

				const states = dataObj.map((id) => {
					const selectedState = multiSelectState.states.filter(
						(state) => state.id === id,
					);
					if (selectedState.length)
						return { name: selectedState[0].name, id: selectedState[0].id };
				});

				data.states = [...states];
			};

			const setEditorData = (payload) => {
				data.description = payload;
			};

			const inputError = (input) => {};
			const inputSuccess = (input) => {};

			return {
				data,
				multiSelectState,

				setCountry,
				setState,
				setEditorData,

				inputError,
				inputSuccess,
			};
		},
	};
</script>
